import script from "./PopoverRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverRoot.vue?vue&type=script&setup=true&lang=ts"

import "./PopoverRoot.vue?vue&type=style&index=0&id=5b622bf0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b622bf0"]])

export default __exports__